import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["className", "clsPrefix"];

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { WebUI } from "../../wui-core/src/index.js";
import BreadcrumbItem from './BreadcrumbItem';
var propTypes = {
  className: PropTypes.string,
  clsPrefix: PropTypes.string,
  onClick: PropTypes.func
};
var defaultProps = {
  onClick: function onClick() {}
};
var Breadcrumb = (_dec = WebUI({
  name: "breadcrumb",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(Breadcrumb, _React$Component);

  var _super = _createSuper(Breadcrumb);

  function Breadcrumb() {
    _classCallCheck(this, Breadcrumb);

    return _super.apply(this, arguments);
  }

  _createClass(Breadcrumb, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          clsPrefix = _this$props.clsPrefix,
          others = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/React.createElement("ol", _extends({}, others, {
        className: classnames(className, clsPrefix)
      }));
    }
  }]);

  return Breadcrumb;
}(React.Component)) || _class);
Breadcrumb.propTypes = propTypes;
Breadcrumb.Item = BreadcrumbItem;
export default Breadcrumb;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-breadcrumb/src/Breadcrumb.js